import { render } from "./One6.vue?vue&type=template&id=dc65831c&scoped=true&lang=pug"
import script from "./One6.vue?vue&type=script&lang=js"
export * from "./One6.vue?vue&type=script&lang=js"

import "./One6.vue?vue&type=style&index=0&id=dc65831c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc65831c"]])

export default __exports__